import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Workshop from "./pages/Workshop";
import ServiceDetail from "./pages/ServiceDetail";
import Contact from "./pages/Contact";
import { NotFound, Forbidden } from "./pages/ErrorPages";

function App() {
  return (
    <>
      {/* Scroll restoration sikrer, at siden altid starter øverst ved ruteskift */}
      <ScrollToTop />
      
      <div className="flex min-h-screen flex-col bg-[#fcfbf9] text-stone-900 antialiased selection:bg-brand-orange/20 selection:text-brand-orange-dark">
        {/* Hovednavigation */}
        <Navbar />
        
        {/* Primært indholdsområde */}
        <main className="flex-grow">
          <Routes>
            {/* Forside */}
            <Route path="/" element={<Home />} />
            
            {/* Værkstedet */}
            <Route path="/vaerkstedet" element={<Workshop />} />
            
            {/* Specifikke ydelsessider (CMS-forbundne via slug) */}
            <Route
              path="/service-og-reparation"
              element={<ServiceDetail slug="service-og-reparation" />}
            />
            <Route
              path="/daek-og-hjul"
              element={<ServiceDetail slug="daek-og-hjul" />}
            />
            <Route
              path="/synsklargoering"
              element={<ServiceDetail slug="synsklargoering" />}
            />
            
            {/* Kontakt */}
            <Route path="/kontakt" element={<Contact />} />
            
            {/* Professionelle fejl-sider */}
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        
        {/* Sidefod */}
        <Footer />
      </div>
    </>
  );
}

export default App;
